import { render } from "./OrganizationManagement.vue?vue&type=template&id=6c650a88&scoped=true"
import script from "./OrganizationManagement.vue?vue&type=script&lang=js"
export * from "./OrganizationManagement.vue?vue&type=script&lang=js"

import "./OrganizationManagement.vue?vue&type=style&index=0&id=6c650a88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c650a88"],['__file',"src/views/UserManagement/OrganizationManagement/OrganizationManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c650a88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c650a88', __exports__)) {
    api.reload('6c650a88', __exports__)
  }
  
  module.hot.accept("./OrganizationManagement.vue?vue&type=template&id=6c650a88&scoped=true", () => {
    api.rerender('6c650a88', render)
  })

}


export default __exports__